'use client';

import {
    Button,
    Checkbox,
    SheetDescription,
    SheetHeader,
    SheetTitle,
} from '@repo/shadcn';

import SheetWrapper from '@/components/ui/sheet.wrapper/sheet-wrapper';

import {
    PermissionType,
    useCreateRolePermission,
} from './create-role-permission.hook';

const CreateRolePermission = () => {
    const {
        resourceData,
        resourceLoading,
        handleSubmit,
        roleName,
        setRoleName,
        permissions,
        handleCheckboxChange,
        roleloading,
    } = useCreateRolePermission();

    return (
        <SheetWrapper position="top">
            <SheetHeader className="mb-5">
                <SheetTitle className=" text-[24px]">
                    Create New Role with Permissions
                </SheetTitle>
                <SheetDescription>
                    Add a role and check resource permissions
                </SheetDescription>
            </SheetHeader>
            {/* TODO add skeleton */}
            <div className=" item-center mt-5 flex w-full flex-col rounded-md border-[1px] p-4">
                {!resourceLoading && (
                    <div className="grid grid-cols-5 bg-white">
                        <div className=" col-span-1 border-b-[1px] bg-white">
                            <p className="p-3.5 font-semibold"> Role Name</p>
                            <input
                                placeholder="Enter Role Name"
                                value={roleName}
                                onChange={(e) => setRoleName(e.target.value)}
                                className=" !focus:border-0 w-full border-[1px] border-r-0 px-3 py-3"
                            />
                        </div>

                        <div className="col-span-4">
                            <div className="mb-1 grid  grid-cols-4 bg-white px-4 py-3">
                                <span className=" col-span-1 font-semibold">
                                    Resource
                                </span>
                                <span className=" col-span-3 text-center font-semibold">
                                    Permissions
                                </span>
                            </div>
                            <div className=" border-[1px] bg-white">
                                {resourceData?.data.map(
                                    (resource: any, i: any) => (
                                        <div
                                            key={resource.name}
                                            className={`grid w-full grid-cols-5 gap-5 border-b-[1px]  p-3 ${
                                                i % 2 && 'bg-slate-100'
                                            }`}
                                        >
                                            <div className="col-span-1">
                                                {resource.name}
                                            </div>
                                            <div className="col-span-4 flex justify-between">
                                                {[
                                                    'read',
                                                    'create',
                                                    'update',
                                                    'delete',
                                                ].map((perm) => (
                                                    <span
                                                        key={perm}
                                                        className="flex items-center gap-2"
                                                    >
                                                        <Checkbox
                                                            checked={
                                                                permissions[
                                                                    resource
                                                                        .name
                                                                ]?.[
                                                                    perm as keyof PermissionType
                                                                ] || false
                                                            }
                                                            onCheckedChange={(
                                                                value,
                                                            ) =>
                                                                handleCheckboxChange(
                                                                    resource.name,
                                                                    perm as keyof PermissionType,
                                                                    value,
                                                                )
                                                            }
                                                            name={perm}
                                                        />
                                                        {perm
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                            perm.slice(1)}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    ),
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <Button
                    disabled={roleloading}
                    onClick={handleSubmit}
                    className="mx-auto mt-4"
                >
                    {roleloading ? 'Submitting' : 'Save & Submit'}
                </Button>
            </div>
        </SheetWrapper>
    );
};

export default CreateRolePermission;
